import Vue from 'vue'
import Vuex from 'vuex'

import zoneFiltersModule from './modules/zoneFiltersModule'
import authModule from './modules/auth'
import vehicles from './modules/vehicles'
import missions from './modules/missions'
import geofences from './modules/geofences'
import alerts from './modules/alerts'
import agencies from './modules/agencies'
import home from './modules/home'
import reports from './modules/reports'
import alarms from './modules/alarms'
import vehicleStatus from './modules/vehicleStatus'
import pusherStore from './modules/pusherStore'
import notifications from './modules/notifications'
import officialZones from './modules/officialZones'
import currentDateTime from './modules/currentDateTime'
import logsHistory from './modules/logsHistory'
import places from './modules/places'
import heatmap from './modules/heatmap'
import sosAlerts from './modules/sosAlerts'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    currentDateTime,
    officialZones,
    notifications,
    pusherStore,
    vehicleStatus,
    alarms,
    reports,
    filters: zoneFiltersModule,
    auth: authModule,
    vehicles,
    missions,
    geofences,
    alerts,
    agencies,
    home,
    logsHistory,
    places,
    heatmap,
    sosAlerts
  },
  strict: debug
})



// WEBPACK FOOTER //
// ./src/store/index.js